import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DatatableComponent } from './components/datatable/datatable.component';

@NgModule({
  declarations: [DatatableComponent],
  imports: [CommonModule, NgxDatatableModule],
  exports: [DatatableComponent],
})
export class DatatableModule {}
